// Opt-in playback: no unexpected motion or full video download on page load.
if (!customElements.get('ballr-install-video-v2')) {
  customElements.define('ballr-install-video-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.dataset.initialized = 'true';
      const sync = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
      button.addEventListener('click', async () => {
        if (video.paused) { try { await video.play(); } catch { /* Native controls remain available. */ } }
        else video.pause();
        sync();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      button.hidden = false;
      sync();
    }
  });
}
